export const heroesBookingListSelector = state => state.whiteLabel.heroesBookingList.get('list');
export const officeDepartmentsSelector = state => state.whiteLabel.heroesBookingList.get('departments');
export const heroesBookingListLoadingSelector = state => state.whiteLabel.heroesBookingList.get('isLoading');